import { useEffect, useCallback, useState } from "react";
import { useActions } from "../useActions";
import { useSelector } from "react-redux";
import { RootState } from "../../state/store";
import { useTypedSelector } from "../useTypedSelector";

function usePushbackDetail(orderId: string) {

    const { getPushbackDetailData } = useActions();
    const accessToken = useSelector((state: RootState) => state.appSlice.accessToken);
    const configId = useSelector((state: RootState) => state.appSlice.configId);
    const { data, error, loading } = useTypedSelector((state) => state.pushbackDetail);
    const [refreshTrigger, setRefreshTrigger] = useState(0);

    const isOrderNumberValid = orderId && orderId.trim() !== "";

    const fetchData = useCallback(() => {
        if (isOrderNumberValid && configId) {
            getPushbackDetailData(configId, accessToken, orderId);
        }
    }, [getPushbackDetailData, accessToken, orderId, isOrderNumberValid, configId]);

    const refresh = useCallback(() => {
        setRefreshTrigger(prev => prev + 1);
    }, []);

    // Effect to fetch data
    useEffect(() => {
        fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [orderId, refreshTrigger]);

    if (!isOrderNumberValid) {
        return { data: null, error: "", loading: false, refresh };
    }

    // Return loading, error, and data for better flexibility
    return { data, loading, error, refresh };
}

export { usePushbackDetail };